require('./helpers/bundle-manifest').register(JSON.parse("{\"cXHa9\":\"theme.js\",\"6TNsU\":\"favicon.png\",\"aWhcp\":\"theme.css\"}"));